<template>
  <div>
    <v-main class="pa-4">
      <div class="d-flex">
        <h2>表單</h2>
        <v-spacer></v-spacer>
        <v-btn @click="add" color="primary" depressed>新增表單</v-btn>
      </div>
      <v-divider class="my-4"></v-divider>
      <v-data-table
        :headers="headers"
        :items="forms"
        :items-per-page="15"
      >
        <template v-slot:[`item.shortcode`]="{ item }">
            {{`[nctu-mentor-booking-form id="${item.id}"]`}}
        </template>
        <template v-slot:[`item.manipulate`]="{ item }">
          <div class="py-4">
            <v-btn @click="edit(item.id)" class="mr-2" color="primary" fab small depressed>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-main>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Forms',
  data: () => ({
    headers: [
      { text: '名稱', value: 'name' },
      { text: '短代碼', value: 'shortcode' },
      { text: '操作', value: 'manipulate' }
    ]
  }),
  async created () {
    if (this.forms.length > 0) return
    this.startLoading()
    await this.$store.dispatch('bindForms')
    this.closeDialog()
  },
  methods: {
    ...mapMutations({
      showDialog: 'SHOW_DIALOG',
      startLoading: 'START_LOADING',
      closeDialog: 'CLOSE_DIALOG'
    }),
    add () {
      this.$router.push({ name: 'FormAdd' })
    },
    edit (formId) {
      this.$router.push({ name: 'FormEdit', params: { formId } })
    }
  },
  computed: {
    ...mapGetters(['forms'])
  }
}
</script>
